<template>
  <div>
    <elements-layout
            :table-columns='tableColumns'
            :fetch-data-url='fetchDataUrl'
            :tableRepresentation="true"
            :store-module-name="STORE_MODULE_NAME"
            :store-module-config="STORE_MODULE_CONFIG"
            :searchFieldActive="false"
    ></elements-layout>

    <report-download-modal
                :is-download-report-modal-active="store.state[STORE_MODULE_NAME].isDownloadReportModalActive"
                @is-download-report-modal-active = "val => store.commit(`${STORE_MODULE_NAME}/SET_IS_DOWNLOAD_REPORT_MODAL_ACTIVE`, val)"

                :download-data-url="downloadDataUrl"
                :report-object="reportDataConstructor(store.state[STORE_MODULE_NAME].downloadReportModalData)"
                :download-report-modal-form-data="downloadReportModalFormData"
                :request-data-constructor="requestDataConstructor"
    >

      <report-download-form slot="form"
                            :report-object="reportDataConstructor(store.state[STORE_MODULE_NAME].downloadReportModalData)"
                            :initial-object="store.state[STORE_MODULE_NAME].downloadReportModalData"
                            @form-data-changed="val => downloadReportModalFormData = val">
      </report-download-form>

    </report-download-modal>

  </div>
</template>

<script>
  import store from '@/store/'
  import {onBeforeMount, onBeforeUnmount} from '@vue/composition-api'

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from './baseReportStoreModule'
  import useBaseReport from './useBaseReport'

  import ReportDownloadModal from "../utils/components/reportDownloadModal/ReportDownloadModal";
  import useReportDownloadModal from "../utils/components/reportDownloadModal/useReportDownloadModal";

  import ReportDownloadForm from "./components/reportDownloadForm/ReportDownloadForm";
  import useReportDownloadForm from "./components/reportDownloadForm/useReportDownloadForm";


  export default {
    components: {
      ReportDownloadForm,
      ReportDownloadModal,
      ElementsLayout,
    },
    setup() {

      // Re-register module with additional options
      onBeforeMount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })


        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      const {
        fetchDataUrl,
        downloadDataUrl,
        tableColumns,
      } = useBaseReport();

      const {
        reportDataConstructor,
        requestDataConstructor
      } = useReportDownloadForm()


      const {
        downloadReportModalData,
        downloadReportModalFormData,

      } = useReportDownloadModal()



      return {
        fetchDataUrl,
        downloadDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        reportDataConstructor,
        requestDataConstructor,

        downloadReportModalData,
        downloadReportModalFormData,

        store

      }
    },
  }
</script>
